import { useWindowSize } from 'react-use';

export const useHeaderScreenSizes = (): {
  mobile: boolean;
  tablet: boolean;
  desktop: boolean;
} => {
  const { width } = useWindowSize();
  return {
    mobile: width < 720,
    tablet: width >= 720 && width < 1280,
    desktop: width >= 1280,
  };
};
